import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _compareRequest = {};
var _compareResponse = {};
var _createMarketListingRequest = { marketListing: '_marketListing' };
var _createMarketListingResponse = { marketListing: '_marketListing' };
var _getMarketListingRequest = {};
var _getMarketListingResponse = { marketListing: '_marketListing' };
var _marketListing = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _queryMarketListingRequest = {};
var _queryMarketListingResponse = { marketListing: '_marketListing' };
var _updateMarketListingRequest = {
    mask: 'google.protobuf.FieldMask',
    marketListing: '_marketListing',
};
var _updateMarketListingResponse = { marketListing: '_marketListing' };
function resolveComWixpressDevcenterAppmarketlistingMarketListingServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/app-market-listing',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/app-market-listing',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/app-market-listing',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/app-market-listing',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/app-market-listing',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/app-market-listing',
                destPath: '',
            },
            {
                srcPath: '/_api/app-market-listing',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/app-market-listing',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/app-market-listing',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/app-market-listing',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/app-market-listing',
                destPath: '',
            },
        ],
        'platform.rise.ai': [
            {
                srcPath: '/v1/marketListings',
                destPath: '/v1/marketListings',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** create a new market listing */
export function createMarketListing(payload) {
    var _a = serializer(_createMarketListingRequest, { _marketListing: _marketListing }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createMarketListingResponse, {
        _marketListing: _marketListing,
    }).fromJSON;
    function __createMarketListing(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.app_market_listing.v1.market_listing',
            method: 'POST',
            methodFqn: 'com.wixpress.devcenter.appmarketlisting.MarketListingService.CreateMarketListing',
            url: resolveComWixpressDevcenterAppmarketlistingMarketListingServiceUrl({
                protoPath: '/v1/marketListings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createMarketListing.fromReq = fromReq;
    __createMarketListing.__isAmbassador = true;
    return __createMarketListing;
}
/** retrieve an existing market listing */
export function getMarketListing(payload) {
    var _a = serializer(_getMarketListingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMarketListingResponse, {
        _marketListing: _marketListing,
    }).fromJSON;
    function __getMarketListing(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.app_market_listing.v1.market_listing',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.appmarketlisting.MarketListingService.GetMarketListing',
            url: resolveComWixpressDevcenterAppmarketlistingMarketListingServiceUrl({
                protoPath: '/v1/marketListings/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMarketListing.fromReq = fromReq;
    __getMarketListing.__isAmbassador = true;
    return __getMarketListing;
}
/** update an existing market listing */
export function updateMarketListing(payload) {
    var _a = serializer(_updateMarketListingRequest, { _marketListing: _marketListing }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMarketListingResponse, {
        _marketListing: _marketListing,
    }).fromJSON;
    function __updateMarketListing(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.app_market_listing.v1.market_listing',
            method: 'PUT',
            methodFqn: 'com.wixpress.devcenter.appmarketlisting.MarketListingService.UpdateMarketListing',
            url: resolveComWixpressDevcenterAppmarketlistingMarketListingServiceUrl({
                protoPath: '/v1/marketListings/{marketListing.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMarketListing.fromReq = fromReq;
    __updateMarketListing.__isAmbassador = true;
    return __updateMarketListing;
}
/** query market listings */
export function queryMarketListing(payload) {
    var _a = serializer(_queryMarketListingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMarketListingResponse, {
        _marketListing: _marketListing,
    }).fromJSON;
    function __queryMarketListing(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.app_market_listing.v1.market_listing',
            method: 'POST',
            methodFqn: 'com.wixpress.devcenter.appmarketlisting.MarketListingService.QueryMarketListing',
            url: resolveComWixpressDevcenterAppmarketlistingMarketListingServiceUrl({
                protoPath: '/v1/marketListings/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMarketListing.fromReq = fromReq;
    __queryMarketListing.__isAmbassador = true;
    return __queryMarketListing;
}
/** compare versions */
export function compare(payload) {
    var _a = serializer(_compareRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_compareResponse, {}).fromJSON;
    function __compare(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.app_market_listing.v1.market_listing',
            method: 'POST',
            methodFqn: 'com.wixpress.devcenter.appmarketlisting.MarketListingService.Compare',
            url: resolveComWixpressDevcenterAppmarketlistingMarketListingServiceUrl({
                protoPath: '/v1/market-listings/compare',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __compare.fromReq = fromReq;
    __compare.__isAmbassador = true;
    return __compare;
}
//# sourceMappingURL=http.impl.js.map